import request from './request'

export function getDiaryMission(query) {
    return request({
        url:'/huhushare/Diary/getDiaryMission',
        method: 'post',
        data: query
    });
}

export function addPraise(query) {
    return request({
        url:'/huhushare/Diary/addPraise',
        method: 'post',
        data: query
    });
}

export function getDiaryActivityData(query) {
    return request({
        url:'/huhushare/Diary/getDiaryActivityData',
        method: 'post',
        data: query
    });
}

//上学日记列表页和详情页
export function attendSchoolDiary(query) {
    return request({
        url:'/huhushare/Diary/attendSchoolDiary',
        method: 'post',
        data: query
    });
}
//上学日记点赞
export function attendSchoolAddPraise(query) {
    return request({
        url:'/huhushare/Diary/attendSchoolPraise',
        method: 'post',
        data: query
    });
}


// WEBPACK FOOTER //
// ./src/api/diary.js